<template>
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px'}">
    <a-form>
      <search-header :col="3">
        <search-list>
          <a-form-item label="设置编号" v-bind="searchItemLayout">
            <a-input v-model="queryParams.settingCode" placeholder="请输入设置编号"></a-input>
          </a-form-item>
          <a-form-item label="状态" v-bind="searchItemLayout">
            <a-select style="width: 100%"
                      v-model="queryParams.status"
                      placeholder="请选择" allowClear
            >
              <a-select-option :value="999">全部</a-select-option>
              <a-select-option :value="0">未开始</a-select-option>
              <a-select-option :value="1">进行中</a-select-option>
              <a-select-option :value="2">已完成</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="企业ID" v-bind="searchItemLayout">
            <a-input
              v-model="queryParams.enterpriseId"
              placeholder="请输入企业ID"
              allowClear
            />
          </a-form-item>
        </search-list>
        <search-list>
          <a-form-item style="margin-left:5%;">
            <a-button type="primary" @click="searchBtn">查询</a-button>
            <a-button type="primary" icon="plus" style="margin-left: 8px;" @click="handleCreate">新建</a-button>
          </a-form-item>
        </search-list>
      </search-header>
    </a-form>
    <custom-page-table
      ref="table"
      rowKey="id"
      :columns="columns"
      :enableSearch="false"
      :request-promise="loadData"
    >
      <span class="price-class" slot="priceSlots" slot-scope="data">￥{{ data.text }}</span>
      <div slot="action" slot-scope="data">
        <a @click="handleDetail(data.record)">查看详情</a>
      </div>
    </custom-page-table>
  </a-card>
</template>

<script>
import searchForm from '@/utils/mixins/searchFormMixins'

export default {
  name: 'Batchorder',
  mixins: [searchForm],
  data() {
    return {
      queryParams: {
        enterpriseId: '',
        settingCode: '',
        status: 999
      },
      columns: [
        {
          title: '设置编号',
          dataIndex: 'settingCode'
        },
        {
          title: '企业ID',
          dataIndex: 'enterpriseId',
          width: '90px'
        },
        {
          title: '部门数',
          dataIndex: 'deptCount',
          width: '90px'
        },
        {
          title: '价格数',
          dataIndex: 'priceCount',
          width: '90px'
        },
        {
          title: '最低起价',
          dataIndex: 'minStartPrice',
          scopedSlots: { customRender: 'priceSlots' },
          width: '110px'
        },
        {
          title: '最高价格',
          dataIndex: 'maxEndPrice',
          scopedSlots: { customRender: 'priceSlots' },
          width: '110px'
        },
        {
          title: '状态',
          dataIndex: 'statusStr',
          width: '90px'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '170px'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '170px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: '100px'
        }
      ]
    }
  },
  methods: {
    // 企业定制游设置分页列表（接口：POST /enterpriseTravelSetting/page）
    loadData(requestParams) {
      const enterpriseId = this.queryParams.enterpriseId === '' || this.queryParams.enterpriseId == null
        ? 0
        : Number(this.queryParams.enterpriseId)
      const params = {
        enterpriseId: Number.isNaN(enterpriseId) ? 0 : enterpriseId,
        settingCode: this.queryParams.settingCode,
        status: this.queryParams.status === 999 ? undefined : this.queryParams.status,
        limitDto: requestParams.limitDto
      }
      return this.getHttpServices().getNewServeService().post('/enterpriseTravelSetting/page', params)
    },
    searchBtn() {
      this.$refs.table.refresh(true)
    },
    handleCreate() {
      this.$router.push({
        name: 'TravelBatchCreate',
        query: {
          backTab: 'batchorder',
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    handleDetail(record) {
      this.$router.push({
        name: 'TravelBatchDetail',
        query: {
          settingCode: record.settingCode,
          backTab: 'batchorder',
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    }
  }
}
</script>
<style scoped>
.price-class {
  color: #fea834;
}
</style>
